import { render, staticRenderFns } from "./ContactInformation.vue?vue&type=template&id=70688cb6&scoped=true&lang=pug"
import script from "./ContactInformation.vue?vue&type=script&lang=js"
export * from "./ContactInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70688cb6",
  null
  
)

export default component.exports